<div
  [isOpen]="activatePopOver && (item.isGroupeBenne || (!item.isGroupeBenne || (item.listeTournees && item.listeTournees.length)) && showPopOver )"
  [popover]="(!item.isGroupeBenne || (item.listeTournees && item.listeTournees.length)) ? popTemplateTournee : (item.isGroupeBenne && !isClickVoirplus ? popTemplateTournee : popTemplate)"
  container="body" triggers="'manual'" class="col-sm-12 contbenne" style="padding: 0;"
  [placement]="placementPopoverInfo" [adaptivePosition]="false" [ngStyle]="{'border-left-color': findCouleur(item)}"
  [ngClass]="{'fixedHeightGrp': addClassGroupCreate}" (mouseenter)="getListArticle();"
  (mouseover)="onMouseOver($event,item)" (mouseleave)="onMouseleave($event, item);">
  <div class="col-sm-12 benne"
    [ngStyle]="{'max-height':  showAllArticle ? '150px' : ((!showcht && !item.isLocation && !item.lieu && !isEditableTypeContenant)) ? '55px' : '90px'}">
    <div class="text-left" style="padding: 6px 0 0 0px; width: 55px; position: relative;">
      <div *ngIf="showNotif && (item.listBon && item.listBon.length)" class="notification"
        [ngStyle]="{'background-color': common.LightenDarkenColor(findCouleur(item), -50)}">
        {{item.listBon.length}}</div>
      <div *ngIf="showIconAdd && (item.listBon && item.listBon.length)" class="notification addMouvSupp"
        [ngStyle]="{'background-color': common.LightenDarkenColor(findCouleur(item), -50)}">
        <i class="fa fa-plus"></i>
      </div>
      <app-svg-benne *ngIf="getIcons(item) === 'benne'" [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)"
        [lightcolor]="findCouleur(item)">
      </app-svg-benne>
      <app-svg-tas *ngIf="getIcons(item) === 'tas'" [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)"
        [lightcolor]="findCouleur(item)">
      </app-svg-tas>
      <app-svg-groupe *ngIf="getIcons(item) === 'groupe'"
        [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)" [lightcolor]="findCouleur(item)">
      </app-svg-groupe>
      <app-svg-fut *ngIf="getIcons(item) === 'fut'" [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)"
        [lightcolor]="findCouleur(item)">
      </app-svg-fut>
      <app-svg-caissepalette *ngIf="getIcons(item) === 'caissepalette'"
        [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)" [lightcolor]="findCouleur(item)">
      </app-svg-caissepalette>
      <app-svg-bigbag *ngIf="getIcons(item) === 'bigbag'"
        [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)" [lightcolor]="findCouleur(item)">
      </app-svg-bigbag>
      <app-svg-bac *ngIf="getIcons(item) === 'bac'" [darkcolor]="common.LightenDarkenColor(findCouleur(item), -50)"
        [lightcolor]="findCouleur(item)">
      </app-svg-bac>
    </div>
    <div *ngIf="champQte" style="width: 60px; position: relative; padding-right: 5px;">
      <ng-template [ngIf]="item.id && item.id < 0">
        <div class="form-group"
          [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}">
          <label *ngIf="item.qteContenant || newprest.qteContenantfocus" style="position: absolute;
          font-size: 11px;
          text-align: left;
          color: rgba(55, 97, 148, 0.6);
          padding: 4px 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;">
            Qté </label>
          <input type="number" step="1" class="form-control info" id="qteContenant" placeholder="Qté" autofocus
            [(ngModel)]="item.qteContenant" (focus)="newprest.qteContenantfocus = true;" style="height: 47px;"
            (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
        </div>
      </ng-template>
      <ng-template [ngIf]="item.id && item.id > 0">
        <div class="form-group"
          [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}">
          <app-autocomplete [placeholder]="'Qté'" [id]="'listQteId'"
            (selectfunction)="qteSelected = $event; setValueQte();" [isCombo]="true" [results]="listQte" [label]="'Qté'"
            [defaultselected]="qteSelected" [container]="true" [selectvalue]="true" [disablefocus]="true"
            [defaultsearch]="qteSelected ? qteSelected.libelleObjetEntite : ''">
          </app-autocomplete>
        </div>
      </ng-template>
    </div>
    <div class="text-left  " [ngClass]="{'col-sm-9': !champQte}" style="padding: 0px 5px; width: calc(100% - 55px);"
      [ngStyle]="{'width': champQte ? 'calc(100% - 110px)' : 'calc(100% - 55px)'}">

      <div *ngIf="isListetourne && item.chantier && item.chantier.client" class="col-sm-12" style="padding: 0px;">
        {{ item.chantier.client.nomClient || '' }}
      </div>

      <div *ngIf="showcht && item.chantier" class="col-sm-12 ellipsis" style="padding: 0px;">
        {{ item.chantier.numChantier || '' }}
      </div>
      <div *ngIf="showcht && item.chantier" class="col-sm-12 ellipsis" style="padding: 0px;">
        {{ item.chantier.ville || '' }}
      </div>
      <div *ngIf="item.isGroupeBenne" class="col-sm-12 ellipsis" style="padding: 0px;">
        Grp. Contenants {{ item.id }}

        <!-- <div>{{item.art.code}}/{{item.art.libelle || item.art.libelleObjetEntite}} </div>   -->
      </div>
      <div *ngIf="!item.isGroupeBenne" class="col-sm-12 ellipsis" style="padding: 0px;">
        <div class="col-sm-12" style="padding: 0;margin-bottom: 5px;" *ngIf="isEditableTypeContenant">
          <app-autocomplete (selectfunction)="item.typeContenant = $event; common.focusElement('.articleCont')"
            [results]="typeContenant" [highlight]="true" [showonclick]="true"
            (searchfunction)="searchTypecontenantByLibelle($event)" [container]="true" [label]="'Type contenant'"
            id="typeContDep" [placeholder]="'Type contenant'" (keyenterfunction)="common.focusElement('.articleCont')"
            [defaultselected]="item.typeContenant" [selectvalue]="true" [disablefocus]="true"
            [defaultsearch]="item.typeContenant ? item.typeContenant.libelleObjetEntite : ''">
          </app-autocomplete>
        </div>

        <div class="col-sm-12" style="padding: 0;" *ngIf="!isEditableTypeContenant">


          <span *ngIf="(showNotif || showQte) && !champQte"> {{ (item.qteContenant || '1') + ' ' }}</span>
          <span *ngIf="item.typeContenant && item.typeContenant.famille"
            style="white-space: nowrap; width: 99%; overflow: hidden;"> {{item.typeContenant.famille.libelle}}
          </span>
          <span *ngIf="item.typeContenant && item.typeContenant.cubage">
            {{item.typeContenant.cubage.cubage || '0'}}</span>
          <span *ngIf="item.typeContenant && item.typeContenant.uniteCont">
            {{item.typeContenant.uniteCont.libelle}} </span>
        </div>

        <div *ngIf="item.isGroupeArticle" class="col-sm-12 ellipsis" style="padding: 0px;">
          Grp Art
        </div>
        <div class="col-sm-12 ellipsis" *ngIf="item.art && !item.isGroupeArticle"
          style="padding: 0px; width: 99%; overflow: hidden;"
          [ngStyle]="{'white-space': (showAllArticle) ? 'normal': 'nowrap'}">
          {{item.art.code}} {{item.isGroupeArticle? '': '/' }} {{item.art.libelle || item.art.libelleObjetEntite}}
        </div>

        <div class="col-sm-12 ellipsis" *ngIf="showNotif" style="padding: 0px;">
          <span *ngIf="!common.isPrestation && item.isLocation && !item.isLocJour">
            Location {{item.isLocImmediat ? 'au retrait': (item.periodeLoc ? item.periodeLoc.libelleObjetEntite : '')}}

          </span>
          <span *ngIf="!common.isPrestation && item.isLocJour && item.isLocation">
            Location
            journalière
          </span>
          <!-- <span *ngIf="item.isLocation && item.isLocJour">
              Location
              journalière /
              Location mensuelle </span> -->
          <span *ngIf="!item.isLocation && !item.isLocJour" style="color: #fff">
          </span>
        </div>
        <div class="col-sm-12 ellipsis" *ngIf="!hide_contrat" style="padding: 0px;">
          <span *ngIf="item.contrat"> Contrat : {{item.numContrat}} </span>
        </div>
        <div class="col-sm-12 ellipsis" style="padding: 0px;" *ngIf="common.isPrestation && item.isLocation">
          <span> Location {{item.isLocImmediat ? 'au retrait' : (item.periodeLoc ? item.periodeLoc.libelleObjetEntite :
            '')}}</span>
        </div>
        <div class="col-sm-12 ellipsis" style="padding: 0px;">
          <span> {{item.lieu && item.lieu.nom || '' }} </span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12" *ngIf="!pasDetailGroupe">
    <div *ngIf="item.isGroupeBenne && item.listBennes && item.listBennes.length">
      <div *ngFor="let contenu of listeBenne6;trackBy:common.trackById; let i = index">
        <p class="ellipsis"> {{contenu.typeContenant &&
          contenu.typeContenant.famille ? contenu.typeContenant.famille.libelle: '' }} , {{contenu.art?contenu.art.code
          :
          '' }} </p>
      </div>
      <label
        style="z-index: 100; position:relative;text-align: left;text-decoration: underline;font: normal normal bold 12px/16px Roboto;letter-spacing: 0px;color: #3A679D;text-transform: uppercase;"
        class="text-left uppercase text-underline" id="Fiche{{item.id}}"
        *ngIf="showVoirFiche && item.listBennes && (item.listBennes.length >5)" (click)="VoirFiche($event,item)" (mouseleave)="isClickVoirplus = false;">Voir
        plus</label>
    </div>
  </div>
  <div class="col-sm-12 ellipsis" *ngIf="item.num" style="padding: 0px 0 0 10px; font-weight: bold;"
    [ngStyle]="{'color': findCouleur(item)}">
    {{ item.num }}
  </div>
</div>

<ng-template #popTemplate>
  <div id="popover" style="color: #000000; font-size: 13px;letter-spacing: 0.5px;width: 276px;"
    *ngIf="item.isGroupeBenne && showPopOver && activatePopOver">
    <div class="header" style='margin-bottom: 15px;'>
      <div *ngIf="infobulle.parking">
        <h3 class='client'>{{infobulle.parking.libelleObjetEntite || ''}}</h3>
        <span style='font-family: Roboto-Regular;' *ngIf="!infobulle.tournee && infobulle.client">
          {{infobulle.client.nomClient}} </span>
        <span style='font-family: Roboto-Regular;' *ngIf="infobulle.tournee">
          {{infobulle.tournee.description || infobulle.tournee.libelleObjetEntite || ''}} </span>
      </div>
      <div *ngIf="!infobulle.parking">
        <h3 class='client' *ngIf="!infobulle.tournee && infobulle.client"> {{infobulle.client.nomClient}} </h3>
        <h3 class='client' *ngIf="infobulle.tournee">
          {{infobulle.tournee.description || infobulle.tournee.libelleObjetEntite || ''}} </h3>
        <span style='font-family: Roboto-Regular;' *ngIf="infobulle.chantier"> {{infobulle.chantier ?
          infobulle.chantier.ville :
          ''}} | {{infobulle.chantier ? infobulle.chantier.numChantier : ''}} </span>
      </div>
      <br />
    </div>
    <div class="col-sm-12" style="font-family: Roboto-Black;">
      <div class='row' style='margin-top: 4px;' *ngIf="infobulle.parking || infobulle.chantier && !infobulle.tournee">
        <div><img src='assets/images/icons/pin.svg' alt='pin' class='pull-left' /></div>
        <div class='col-sm-10 pull-right'>
          <div *ngIf="infobulle.chantier">
            <span *ngIf="infobulle.parking && infobulle.chantier"> {{infobulle.chantier ? infobulle.chantier.ville :
              ''}} | {{infobulle.chantier ? infobulle.chantier.numChantier : ''}} </span>
          </div>
          <div *ngIf="infobulle.chantier"> {{infobulle.chantier.adresse1}} </div>
          <div *ngIf="infobulle.chantier">{{infobulle.chantier.adresse2 || ''}}</div>
          <div *ngIf="infobulle.chantier">{{infobulle.chantier.adresse3 || ''}}</div>
          <div *ngIf="infobulle.chantier">{{(infobulle.chantier.codePostal || '')}}
            {{(infobulle.chantier.ville || '')}}</div>
          <div *ngIf="infobulle && infobulle.lieu">
            <span> {{infobulle.lieu.nom || ''}} </span>
          </div>
          </div>
      </div>

      <div class='row' style='margin-top: 4px;' *ngIf="infobulle.tournee">
        <div><img src='assets/images/icons/pin.svg' alt='pin' class='pull-left' /></div>
        <div class='col-sm-10 pull-right'>
          <div>
            Client : {{ infobulle.tournee.multiClient ? 'Multi Client' :
            (infobulle.tournee.client ? ((infobulle.tournee.client.codeClient ? (infobulle.tournee.client.codeClient +
            '/') : '') + (infobulle.tournee.client.nomClient || '')) : '')
            }}
          </div>

        </div>
      </div>
      <div class='row' style='margin-top: 4px;'>
        <img src='assets/images/icons/outil.svg' alt='outil' class='pull-left' />
        <div class='col-sm-10 pull-right outil' style='padding-top:8px; '>
          <div *ngIf="infobulle.tournee">Flux : {{
            (infobulle.tournee.article ? infobulle.tournee.article.libelle : 'Multi Flux')
            }}
          </div>

          <div *ngIf="infobulle.tournee && infobulle.tournee.compaction">Compaction
          </div>
          <div *ngIf="infobulle && !infobulle.tournee">
            <div *ngIf="infobulle.isGroupeBenne">
              <div *ngIf="infobulle.listBennes && infobulle.listBennes.length > 0">
                <hr />
                <div *ngFor="let benne of infobulle.listBennes;trackBy:common.trackById;">
                  <div *ngIf="benne.typeContenant">{{benne.qteContenant || 0}} {{benne.typeContenant ?
                    (benne.typeContenant.famille ? benne.typeContenant.famille.libelle
                    + ' ' : '') + (benne.typeContenant.cubage ?
                    (benne.typeContenant.cubage.cubage || '0') + ' ' : '') +
                    (benne.typeContenant.uniteCont ?
                    benne.typeContenant.uniteCont.libelle : '') : ''}}</div>
                  <div *ngIf="benne.code !== ''"> {{ benne.code }}</div>
                  <div> {{benne.isGroupeArticle ? 'Grp. Art' : (benne.art ?
                    benne.art.libelle : '')}} </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <div> {{infobulle.camion ? infobulle.camion.immatriculation : ''}} </div>
        </div>
      </div>

      <div *ngIf="infobulle.heure" class='row infoSupp'>
        <img src='assets/images/icons/heure.svg' alt='heure' class='pull-left' />
        <div class='col-sm-10 pull-right'> {{infobulle.heure || '00:00'}} </div>
      </div>

      <div *ngIf="infobulle.infoSup || (infobulle && infobulle.infos)" class='row infoSupp'>
        <i class='fa fa-file-text-o pull-left' aria-hidden='true'></i>
        <div class='col-sm-10 pull-right'> {{infobulle.infoSup || ''}}
          <div *ngIf="infobulle && infobulle.infos"> {{infobulle.infos || ' - '}}</div>
        </div>
      </div>

      <div *ngIf="infobulle.exutoire && !infobulle.tournee" class='row infoSupp'>
        <i class='fa fa-map-marker pull-left' aria-hidden='true' style="font-size: 28px;"></i>
        <div class='col-sm-10 pull-right'>
          <div style='padding: 3px 7px;'> {{infobulle.exutoire.nom || ''}} </div>
        </div>
      </div>
      <div *ngIf="infobulle.tournee && infobulle.tournee.exutoire" class='row infoSupp'>
        <i class='fa fa-map-marker pull-left' aria-hidden='true' style="font-size: 28px;"></i>
        <div class='col-sm-10 pull-right'>
          <div>
            {{ (infobulle.tournee.exutoire ? infobulle.tournee.exutoire.nom : '') }}
          </div>
        </div>
      </div>

      <div *ngIf="infobulle.log" class='row infoSupp'>
        <i class='fa fa-pencil-square-o pull-left' aria-hidden='true' style='padding-top: 5px;'></i>
        <div class='col-sm-10 pull-right'>
          <div> {{infobulle.log.user ? ('Modifiée par ' + ((infobulle.log.user.prenom || '') + ' ' +
            (infobulle.log.user.nom
            || ''))) : ''}} </div>
          <div> {{infobulle.log.user ? 'Le' : 'Modifiée le'}} : {{infobulle.log.date.slice(0, -9) || ''}}
          </div>
        </div>
      </div>

      <div *ngIf="infobulle && infobulle.dernierChauff" class='row infoSupp'>
        <i class='fa fa-pencil-square-o pull-left' aria-hidden='true' style='padding-top: 5px;'></i>
        <div class='col-sm-10 pull-right'>
          <div> Dernier Mouv. le {{infobulle.dateDernierMouv || ''}}</div>
          <div> réalisé par {{infobulle.dernierChauff.prenom || ''}}
            {{infobulle.dernierChauff.nom || ''}}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #popTemplateTournee>
  <div id="popover" style="color: #000000; font-size: 13px;letter-spacing: 0.5px;width: 420px;max-width: 420px;"
    *ngIf="showPopOver && activatePopOver && !isClickVoirplus">
    <div class="col-sm-12" style='margin-bottom: 2px;padding: 0;'>
      <ng-template [ngIf]="!item.isGroupeBenne">
        <div class="col-sm-12" style="padding: 0;">
          <span *ngIf="(showNotif || showQte) && !champQte"> {{ (item.qteContenant || '1') + ' ' }}</span>
          <span *ngIf="item.typeContenant && item.typeContenant.famille"
            style="white-space: nowrap; width: 99%; overflow: hidden;"> {{item.typeContenant.famille.libelle}}
          </span>
          <span *ngIf="item.typeContenant && item.typeContenant.cubage">
            {{item.typeContenant.cubage.cubage || '0'}} </span>
          <span *ngIf="item.typeContenant && item.typeContenant.uniteCont">
            {{item.typeContenant.uniteCont.libelle}} </span> 
        </div>
        <div class="col-sm-12 p-0"  *ngIf="societe?.tsLieuPlanning && item?.chantier?.listLieu?.length">
          <div class="row mx-1 my-1 gap-1" >
            Lieu: <div class="d-flex"  *ngFor="let lieu of item.chantier.listLieu; let i = index">
              {{ i + 1 }}/ {{ lieu.nom }}
              <span *ngIf="i < item.chantier.listLieu.length - 1"> &nbsp;, &nbsp;</span>
            </div>
          </div>
        </div>
          <div *ngIf="(!societe?.tsLieuPlanning ) && infobulle?.lieu">
            <span>{{ infobulle.lieu.nom || '' }}</span>
          </div>
        <div *ngIf="item.isGroupeArticle" class="col-sm-12 ellipsis" style="padding: 0px;">
          Grp Article :
          <div class="col-sm-12" id="autofocus" style="padding: 2px 0; font: normal normal 400 13px Roboto;"
            *ngFor="let item of item.listArticles; let i = index;">
            - {{item.libelle || ''}}
          </div>
        </div>
        <div class="col-sm-12 ellipsis" *ngIf="!item.isGroupeArticle && item.art"
          style="padding: 0px;white-space: nowrap; width: 99%; overflow: hidden;">
          {{item.art.libelle || item.art.libelleObjetEntite}}
        </div>
      </ng-template>

      <ng-template [ngIf]="item.isGroupeBenne">
        <div class="col-sm-12 ellipsis" style="padding: 0px;">
          Grp. Contenants {{ item.id }}
        </div>
      </ng-template>

      <table class="col-sm-12 table table-bordered-none mb-0"
        style="font-size: 12px ! important;padding: 0 ! important;" *ngIf="item.listBon && item.listBon.length">
        <tbody style="font-size: 12px ! important;">
          <tr *ngFor="let bon of item.listBon;trackBy:common.trackById;">
            <td>{{bon.date }}</td>
            <td>{{bon.numBon}}</td>
            <td> {{!item.isGroupeBenne ? bon.libelleOperationBenne : 'Groupe' }}</td>
            <td *ngIf="bon.chauffeur">{{ bon.chauffeur.nom }} {{bon.chauffeur.prenom}} </td>
            <td *ngIf="!bon.chauffeur">NON ASSIGNE </td>
            <td>{{bon.camion ? bon.camion.numParc : '' }}</td>
            <td>{{ bon.camion? bon.camion.immatriculation : '' }}</td>
          </tr>
        </tbody>
      </table>
      
    </div>

    <div class="col-sm-12" style="font-family: Roboto-Black; padding: 0px;"
      *ngIf="infobulle && infobulle.listeTournees && infobulle.listeTournees.length">
      <div *ngIf="infobulle.listeTournees && infobulle.listeTournees.length" style='margin-bottom: 5px;'>
        <h6 class='client'> Tournée{{infobulle.listeTournees && infobulle.listeTournees.length > 1 ? 's' : ''}} : </h6>
      </div>
      <div class='row' style='margin-top: 4px;' *ngFor="let tournee of item.listeTournees;trackBy:common.trackById;">
        <div class='col-sm-12 pull-right'>
          - {{ tournee.description || tournee.libelleObjetEntite || '' }}
        </div>
      </div>
    </div>
  </div>
  <div id="popover" style="color: #000000; font-size: 13px;letter-spacing: 0.5px;width: 420px;"
    *ngIf="item.isGroupeBenne && showPopOver && activatePopOver && isClickVoirplus">
    <div class="header" style='margin-bottom: 6px;'>
      <div *ngIf="infobulle.parking">
        <h3 class='client'>{{infobulle.parking.libelleObjetEntite || ''}}</h3>
        <span style='font-family: Roboto-Regular;' *ngIf="!infobulle.tournee && infobulle.client">
          {{infobulle.client.nomClient}} </span>
        <span style='font-family: Roboto-Regular;' *ngIf="infobulle.tournee">
          {{infobulle.tournee.description || infobulle.tournee.libelleObjetEntite || ''}} </span>
      </div>
      <div *ngIf="!infobulle.parking">
        <h3 class='client' *ngIf="!infobulle.tournee && infobulle.client"> {{infobulle.client.nomClient}} </h3>
        <h3 class='client' *ngIf="infobulle.tournee">
          {{infobulle.tournee.description || infobulle.tournee.libelleObjetEntite || ''}} </h3>
        <span style='font-family: Roboto-Regular;' *ngIf="infobulle.chantier"> {{infobulle.chantier ?
          infobulle.chantier.ville :
          ''}} | {{infobulle.chantier ? infobulle.chantier.numChantier : ''}} </span>
      </div>
      <br />
    </div>
    <div class="col-sm-12" style="font-family: Roboto-Black;">
      <div class='row' style='margin-top: 2px;' *ngIf="infobulle.parking || infobulle.chantier && !infobulle.tournee">
        <div><img src='assets/images/icons/pin.svg' alt='pin' class='pull-left' /></div>
        <div class='col-sm-10 pull-right'>
          <div *ngIf="infobulle.chantier">
            <span *ngIf="infobulle.parking && infobulle.chantier"> {{infobulle.chantier ? infobulle.chantier.ville :
              ''}} | {{infobulle.chantier ? infobulle.chantier.numChantier : ''}} </span>
          </div>
          <div *ngIf="infobulle.chantier"> {{infobulle.chantier.adresse1}} </div>
          <div *ngIf="infobulle.chantier">{{infobulle.chantier.adresse2 || ''}}</div>
          <div *ngIf="infobulle.chantier">{{infobulle.chantier.adresse3 || ''}}</div>
          <div *ngIf="infobulle.chantier">{{(infobulle.chantier.codePostal || '')}}
            {{(infobulle.chantier.ville || '')}}</div>
          <div *ngIf="infobulle && infobulle.lieu">
            <span> {{infobulle.lieu.nom || ''}} </span>
          </div>
          </div>
      </div>

      <div class='row' style='margin-top: 2px;' *ngIf="infobulle.tournee">
        <div><img src='assets/images/icons/pin.svg' alt='pin' class='pull-left' /></div>
        <div class='col-sm-10 pull-right'>
          <div>
            Client : {{ infobulle.tournee.multiClient ? 'Multi Client' :
            (infobulle.tournee.client ? ((infobulle.tournee.client.codeClient ? (infobulle.tournee.client.codeClient +
            '/') : '') + (infobulle.tournee.client.nomClient || '')) : '')
            }}
          </div>

        </div>
      </div>
      <div class='row' style='margin-top: 2px;'>
        <img src='assets/images/icons/outil.svg' alt='outil' class='pull-left' />
        <div class='col-sm-10 pull-right outil' style='padding-top:8px; '>
          <div *ngIf="infobulle.tournee">Flux : {{
            (infobulle.tournee.article ? infobulle.tournee.article.libelle : 'Multi Flux')
            }}
          </div>

          <div *ngIf="infobulle.tournee && infobulle.tournee.compaction">Compaction
          </div>
          <div *ngIf="infobulle && !infobulle.tournee">
            <div *ngIf="infobulle.isGroupeBenne">
              <div *ngIf="infobulle.listBennes && infobulle.listBennes.length > 0">
                <hr />
                <div *ngFor="let benne of infobulle.listBennes;trackBy:common.trackById;">
                  <div *ngIf="benne.typeContenant">{{benne.qteContenant || 0}} {{benne.typeContenant ?
                    (benne.typeContenant.famille ? benne.typeContenant.famille.libelle
                    + ' ' : '') + (benne.typeContenant.cubage ?
                    (benne.typeContenant.cubage.cubage || '0') + ' ' : '') +
                    (benne.typeContenant.uniteCont ?
                    benne.typeContenant.uniteCont.libelle : '') : ''}}</div>
                  <div *ngIf="benne.code !== ''"> {{ benne.code }}</div>
                  <div> {{benne.isGroupeArticle ? 'Grp. Art' : (benne.art ?
                    benne.art.libelle : '')}} </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <div> {{infobulle.camion ? infobulle.camion.immatriculation : ''}} </div>
        </div>
      </div>

      <div *ngIf="infobulle.heure" class='row infoSupp'>
        <img src='assets/images/icons/heure.svg' alt='heure' class='pull-left' />
        <div class='col-sm-10 pull-right'> {{infobulle.heure || '00:00'}} </div>
      </div>

      <div *ngIf="infobulle.infoSup || (infobulle && infobulle.infos)" class='row infoSupp'>
        <i class='fa fa-file-text-o pull-left' aria-hidden='true'></i>
        <div class='col-sm-10 pull-right'> {{infobulle.infoSup || ''}}
          <div *ngIf="infobulle && infobulle.infos"> {{infobulle.infos || ' - '}}</div>
        </div>
      </div>

      <div *ngIf="infobulle.exutoire && !infobulle.tournee" class='row infoSupp'>
        <i class='fa fa-map-marker pull-left' aria-hidden='true' style="font-size: 28px;"></i>
        <div class='col-sm-10 pull-right'>
          <div style='padding: 3px 7px;'> {{infobulle.exutoire.nom || ''}} </div>
        </div>
      </div>
      <div *ngIf="infobulle.tournee && infobulle.tournee.exutoire" class='row infoSupp'>
        <i class='fa fa-map-marker pull-left' aria-hidden='true' style="font-size: 28px;"></i>
        <div class='col-sm-10 pull-right'>
          <div>
            {{ (infobulle.tournee.exutoire ? infobulle.tournee.exutoire.nom : '') }}
          </div>
        </div>
      </div>

      <div *ngIf="infobulle.log" class='row infoSupp'>
        <i class='fa fa-pencil-square-o pull-left' aria-hidden='true' style='padding-top: 5px;'></i>
        <div class='col-sm-10 pull-right'>
          <div> {{infobulle.log.user ? ('Modifiée par ' + ((infobulle.log.user.prenom || '') + ' ' +
            (infobulle.log.user.nom
            || ''))) : ''}} </div>
          <div> {{infobulle.log.user ? 'Le' : 'Modifiée le'}} : {{infobulle.log.date.slice(0, -9) || ''}}
          </div>
        </div>
      </div>

      <div *ngIf="infobulle && infobulle.dernierChauff" class='row infoSupp'>
        <i class='fa fa-pencil-square-o pull-left' aria-hidden='true' style='padding-top: 5px;'></i>
        <div class='col-sm-10 pull-right'>
          <div> Dernier Mouv. le {{infobulle.dateDernierMouv || ''}}</div>
          <div> réalisé par {{infobulle.dernierChauff.prenom || ''}}
            {{infobulle.dernierChauff.nom || ''}}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>